import { getCountriesWatcher } from './get-countries.saga';

export default [
  getCountriesWatcher(),
];
